import type { RecipientGroupType as ApiRecipientGroupType } from 'src/api/generated/touring/types';
import { mapRecipientCustomType } from '../mapRecipientCustomType';
import { mapRecipientType } from '../mapRecipientType';
import type { RecipientGroupType } from '../../types';

export const mapRecipientGroupType = (
  api: ApiRecipientGroupType
): RecipientGroupType => ({
  id: api.id,
  label: api.label,
  personRecipients: api.personRecipients.map(mapRecipientType),
  customRecipients: api.customRecipients.map(mapRecipientCustomType),
  onlyCcRecipientSet: api.onlyCcRecipientSet,
});
